import _objectSpread from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
export var sanitizeChannelSplitterOptions = function sanitizeChannelSplitterOptions(options) {
  return _objectSpread(_objectSpread({}, options), {}, {
    channelCount: options.numberOfOutputs
  });
};